
import api from "@/api";
import { Operator } from "@/api/dtos/Operator.schema";
import { OperatorContactData } from "@/api/dtos/OperatorContactData.schema";
import { countries } from "@/misc/countries";
import { deepClone } from "@/misc/helpers";
import { Component, Prop, Vue } from "vue-property-decorator";
import EditFrame from "../EditFrame.vue";
import EditActionButtons from "../EditActionButtons.vue";
import { showToast } from "@/utils/toastService";
import { getAxiosResponse } from "@/utils/errorUtils";

@Component({
  components: {
    EditFrame,
    EditActionButtons,
  },
})
export default class OperatorContactDataForm extends Vue {
  @Prop()
  operator!: Operator;

  editedContactData: OperatorContactData | null = null;

  mounted(): void {
    this.editedContactData = deepClone(this.operator.contact);
  }

  get countrySelectItems(): {
    value: string;
    text: string;
  }[] {
    return countries.map((c) => {
      return {
        value: c.alpha2.toUpperCase(),
        text: c.name,
      };
    });
  }

  get needsFeedbackEmail(): boolean {
    return this.operator.allowFeedback;
  }

  $refs!: {
    editFrame: EditFrame;
  };
  isEditing = false;
  async onSave(): Promise<void> {
    if (!this.editedContactData) return;

    try {
      await api.OperatorsApi.updateOperatorContactData(
        this.operator.uuid,
        this.editedContactData
      );

      showToast({
        message: "Kontaktdaten erfolgreich aktualisiert",
        type: "success",
      });
    } catch (e) {
      console.error("Contact data update error:", e);
      showToast({
        response: getAxiosResponse(e),
        message: "Kontaktdaten konnten nicht aktualisiert werden",
        type: "error",
      });
    }
  }

  onCancel(): void {
    this.editedContactData = deepClone(this.operator.contact);
  }
}
